import { APIApartmentNotificationRes } from './use-apartment-notification';
import { MarketTypes } from '../types';
import useFilterPaginatedData from './use-filter-paginated-data';
import { TWallMaterial } from 'lib/types';

export type Filter = {
  id: number;
  title: string;
  parameterCount: number;

  areaFrom?: number;
  areaTo?: number;
  pricePerSqMFrom?: number;
  pricePerSqMTo?: number;
  priceTo: number;
  priceFrom?: number;
  bedroomCount?: number[];
  wallMaterials?: TWallMaterial[];
  facilityTypeIds?: number[];
  floors?: number[];
  floorCount?: number[];
  commissioningYears?: number[];
};

export type ApartmentFilterNotification = {
  createdAt: string;
  filter: Filter;
  unreadCount: number;
  id: number;
  title: string;
};

const useApartmentFilterNotification = (isSecondaryMode?: boolean) => {
  const result = useFilterPaginatedData<APIApartmentNotificationRes, ApartmentFilterNotification>(
    '/filter-notifications/search',
    'post',
    // @ts-ignore
    ({ notifications, count }) => {
      return { notification: notifications, count };
    },
    { marketType: isSecondaryMode ? MarketTypes.SECONDARY : MarketTypes.PRIMARY },
  );
  return result;
};

export default useApartmentFilterNotification;
